// routes
import { paths } from '@routes/paths';
import { TokenDecodedTypeConvert, TokenDecodedType } from '@authentication/types';
import { STORAGE_KEYS } from '@constants/storage-keys';
import axios from 'axios';
// utils

// ----------------------------------------------------------------------

function jwtDecode(token: string) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken: string) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;

  return decoded.exp > currentTime;
};

// ----------------------------------------------------------------------

export const tokenExpired = (exp: number) => {
  let expiredTimer;

  const currentTime = Date.now();

  const timeLeft = exp * 1000 - currentTime;

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    alert('Token expired');

    sessionStorage.removeItem('accessToken');

    window.location.href = paths.auth.login;
  }, timeLeft);
};

// ----------------------------------------------------------------------

export const setSession = (accessToken: string | null, refreshToken: string | null) => {
  if (accessToken && refreshToken) {
    sessionStorage.setItem(STORAGE_KEYS.APP_STATE.ACCESS_TOKEN, accessToken);
    sessionStorage.setItem(STORAGE_KEYS.APP_STATE.REFRESH_TOKEN, refreshToken ?? '');

    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;

    // This function below will handle when token is expired
    // TODO: Do a better way to handle token expired
    // tokenExpired(exp);
  } else if (accessToken) {
    sessionStorage.setItem(STORAGE_KEYS.APP_STATE.ACCESS_TOKEN, accessToken);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    sessionStorage.removeItem(STORAGE_KEYS.APP_STATE.ACCESS_TOKEN);
    sessionStorage.removeItem(STORAGE_KEYS.APP_STATE.REFRESH_TOKEN);

    delete axios.defaults.headers.common.Authorization;
  }
};

export const setUserData = (token: string) => {
  const decoded = jwtDecode(token) as TokenDecodedType;

  sessionStorage.setItem('userData', JSON.stringify(decoded));
};

export const getUserPersistedOnLocalStorage = () => {
  const user = sessionStorage.getItem('userData');

  return user ? TokenDecodedTypeConvert.toTokenDecodedType(user) : null;
};
